import React from 'react';
import { BorrowerMutation, LoanMutation } from '../app/mutations';
import RelayEnvironment from '../relay-environment';

const handleError = (path, router) => {
  router.replace(`/${path}/error`);
};

export default (Deck, path) =>
  class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        saving: false
      };
    }

    componentDidMount() {
      this.onSuccess = () => {
        this.setState({ saving: false });
      };
      this.onFailure = (transaction) => {
        this.setState({ saving: false });
        handleError(path, this.props.router, transaction.getError().status);
      };

      this.timer = setInterval(() => {
        this.props.relay.forceFetch({}, ({ ready, done, stale, error }) => {
          const isErrorActive = this.props.router.isActive(`/${path}/error`);
          if (error) {
            handleError(path, this.props.router, error.response && error.response.status);
          } else if (ready && done && !stale && isErrorActive) {
            this.props.router.replace(`/${path}`);
          }
        });
      }, 30000);
    }

    componentWillUnmount() {
      clearInterval(this.timer);
      delete this.timer;
      // Cleanup callbacks so that we don't receive them after the component
      // is unmounted.
      this.onSuccess = () => {
        // ... no-op
      };
      this.onFailure = () => {
        // ... no-op
      };
    }

    render() {
      const { router, ...props } = this.props;
      return (
        <Deck
          {...props}
          saving={this.state.saving}
          updateBorrower={({ borrower, fields }) => {
            this.setState({ saving: true });
            RelayEnvironment.commitUpdate(new BorrowerMutation({ borrower, fields }), {
              onSuccess: () => this.onSuccess(),
              onFailure: (transaction) => this.onFailure(transaction)
            });
          }}
          updateLoan={({ loan, fields }) => {
            this.setState({ saving: true });
            RelayEnvironment.commitUpdate(new LoanMutation({ loan, fields }), {
              onSuccess: () => this.onSuccess(),
              onFailure: (transaction) => this.onFailure(transaction)
            });
          }}
        >
          {this.props.children}
        </Deck>
      );
    }
  };



// WEBPACK FOOTER //
// ./src/components/questionnaire/deck-wrapper.js